// Messages (ru)

const config = {
  code: 'ru',
  label: 'Русский',
  label_en: 'Russian',
  rtl: false,
};

const messages = {
  // Navbar
  navbar_title: 'Отписаться',

  // Unsubscribe page
  unsubpage_title: 'Вы уверены, что хотите отписаться?',
  unsubpage_msg1:
    'Если вы больше не хотите получать от нас маркетинговые сообщения, нажмите кнопку отмены подписки ниже для подтверждения.',
  unsubpage_unsubscribe: 'Отписаться',
  unsubpage_unsubscribing: 'Отказ от подписки...',
  unsubpage_result_success: 'Вы отписались.',
  unsubpage_result_error: 'Отмена подписки не удалась.',

  // Error page
  errorpage_title: 'Упс!',
  errorpage_msg1: 'Данная ссылка для отмены подписки недействительна.',
  errorpage_msg2: 'Мы не смогли продолжить.',
};

const lang = { config, messages };

export default lang;
